module.exports = __webpack_public_path__ + "static/media/338.ce5bb9a3.svg";